<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-align-center ion-align-items-center m-2 !flex h-full justify-center text-base">
        <div
            class="flex-column flex h-auto w-full rounded-2xl bg-white dark:border-2 dark:border-solid dark:border-contrast-yellow">
            <div
                class="flex flex-none items-center justify-between border-b border-solid p-2 dark:border-contrast-yellow">
                <div class="w-10"></div>
                <h2
                    class="journey-filter-title__text var-app-light-dark:font-bold var-app-light:text-black orb-app-light-dark:font-bold text-center font-semibold"
                    ridangoAutofocus
                    tabindex="-1">
                    {{ 'FILTER_SEARCH' | translate }}
                </h2>
                <button
                    class="journey-filter-title__button var-app-light:text-grey-zambezy orb-app-light:text-grey-zambezy h-10 w-10 !leading-none"
                    [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                    (click)="closeModal()"
                    mat-icon-button>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <!-- Filters -->
            <div class="content flex-1 overflow-y-auto border-b border-solid dark:border-contrast-yellow">
                <rwidget-journey-planner-filter
                    [currentFilter]="filter"
                    (filterChanged)="filterChangedHandler($event)"
                    (filterReady)="filterReadyHandler()">
                </rwidget-journey-planner-filter>
            </div>

            <div class="m-4 flex-none">
                <button
                    class="flex-align-center sr-app-light:text-primary var-app-light:text-primary vl-app-light:text-primary orb-app-light-dark:font-semibold orb-app-light-dark:gap-0 mb-2 flex h-14 w-full justify-center gap-2 rounded-lg bg-transparent font-bold text-secondary dark:bg-contrast-yellow dark:text-contrast-black"
                    [attr.aria-label]="'RESET' | translate"
                    (click)="handleResetClicked()">
                    <ion-icon
                        class="var-app-light-dark:text-[2rem] orb-app-light-dark:text-[2rem] text-base"
                        aria-hidden="true"
                        src="{{ assetsPath$ | async }}/img/journey-planner/reset.svg"></ion-icon>
                    <span class="orb-app-light-dark:text-xm">{{ 'RESET' | translate }}</span>
                </button>

                <button
                    class="sr-app-light:bg-secondary vl-app-light:bg-secondary-button vl-app-light:text-black var-app-light:text-primary var-app-light-dark:font-semibold orb-app-light:bg-primary orb-app-light:text-black orb-app-light-dark:font-semibold h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                    (click)="handleNextClick()">
                    {{ 'SAVE_SETTINGS' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
